module.exports = __webpack_public_path__ + "img/08205713000101.85fdf0da.png";